import React from 'react'
import Button from 'components/Button/Button'
import {
  TableItemBody,
  TableItemContainer,
} from 'components/Table/Table.styled'
import { DiscardedAppointmentItemProps } from './DiscardedAppointment.props'
import { DiscardedAppointmentItemText } from './DiscardedAppointment.styled'
import moment from 'moment'

const DiscardedAppointmentItem: React.FC<DiscardedAppointmentItemProps> = ({
  discarded,
  onRestore,
}) => {
  return (
    <TableItemContainer>
      <TableItemBody justify="center">
        <DiscardedAppointmentItemText>
          {moment(discarded.discarded_at).format('MM/DD/YYYY')}
        </DiscardedAppointmentItemText>
      </TableItemBody>
      <TableItemBody justify="center">
        <DiscardedAppointmentItemText>
          {discarded.deleting_user.title}
        </DiscardedAppointmentItemText>
      </TableItemBody>
      <TableItemBody justify="center">
        <DiscardedAppointmentItemText>
          {discarded.user && discarded.user.title}
          {!discarded.user && discarded.program.name}
        </DiscardedAppointmentItemText>
      </TableItemBody>
      <TableItemBody justify="center">
        <DiscardedAppointmentItemText>
          {moment(discarded.date).format('MM/DD/YYYY')},{' '}
          {moment(discarded.start_time).format('LT')} - {''}
          {moment(discarded.end_time).format('LT')}
        </DiscardedAppointmentItemText>
      </TableItemBody>
      <TableItemBody justify="center">
        <Button
          preset={'ghost'}
          variant={'primary'}
          text={'Restore'}
          size={'tiny'}
          onClick={onRestore}
        />
      </TableItemBody>
    </TableItemContainer>
  )
}

export default DiscardedAppointmentItem
